module.exports = __webpack_public_path__ + "img/fabric.0ecb54f0.png";